import React from 'react';

import { StyledDivider } from './Divider.style';

const Divider: React.FC = () => {
  return (
    <StyledDivider />
  );
};

export default Divider;
